export const SERVER_URL = "https://do-calculate.com/api";

export const physicsCalculators_Fr = [
  // EXISTING CALCULATORS
  {
    name: "Calculatrice d'heure d'arrivée",
    link: "/calculator/fr/arrivaltime/",
    description:
      "La calculatrice d'heure d'arrivée calcule le temps qu'il faut à une personne, un véhicule ou un objet en mouvement pour atteindre une destination en fonction de la vitesse et de la distance.",
    showMain: true,
  },
  {
    name: "Calculatrice de mètre cube",
    link: "/calculator/fr/cubicmeter/",
    description:
      "Cette calculatrice calcule le mètre cube - calculatrice électronique de mètre cube - apprenez à calculer le mètre cube.",
    showMain: true,
  },
  {
    name: "Calculatrice de puissance de lentille",
    link: "/calculator/fr/lenspower/",
    description:
      "La calculatrice électronique de puissance de lentille calcule précisément la puissance de la lentille oculaire (dioptrie) rapidement et précisément.",
    showMain: true,
  },
  {
    name: "Calculatrice de charge électrique",
    link: "/calculator/fr/electric-charge/",
    description:
      "La calculatrice de charge électrique calcule la valeur de la charge électrique en fonction de la force entre deux corps chargés.",
    showMain: true,
  },
  {
    name: "Calculatrice de vitesse",
    link: "/calculator/fr/velocity/",
    description:
      "La calculatrice de vitesse calcule la vitesse en fonction de la distance et du temps.",
    showMain: true,
  },
  {
    name: "Calculatrice d'accélération",
    link: "/calculator/fr/acceleration/",
    description:
      "La calculatrice d'accélération calcule l'accélération en fonction des changements de vitesse et du temps.",
    showMain: true,
  },
  {
    name: "Calculatrice d'énergie photonique",
    link: "/calculator/fr/photonenergy/",
    description:
      "La calculatrice d'énergie photonique calcule l'énergie du photon en fonction de la fréquence du photon et de la constante de Planck.",
    showMain: false,
  },
  {
    name: "Calculatrice de force de friction",
    link: "/calculator/fr/frictionforce/",
    description:
      "La calculatrice de force de friction calcule la force de friction en fonction de l'accélération et de la masse.",
    showMain: false,
  },
  {
    name: "Calculatrice de puissance du moteur",
    link: "/calculator/fr/horsepower/",
    description:
      "Utilisez la calculatrice de puissance du moteur pour estimer la puissance du moteur de votre véhicule. Entrez les détails clés et obtenez des résultats précis.",
    showMain: true,
  },

  // NEW PHYSICS CALCULATORS (22)
  {
    name: "Calculatrice d'accélération",
    link: "/calculator/fr/acceleration/",
    description:
      "La calculatrice d'accélération calcule l'accélération en fonction du changement de vitesse et du temps.",
    showMain: true,
  },
  {
    name: "Calculatrice de temps d'arrivée",
    link: "/calculator/fr/arrival-time/",
    description:
      "La calculatrice de temps d'arrivée estime votre heure d'arrivée.",
    showMain: true,
  },
  {
    name: "Calculatrice d'énergie électrique",
    link: "/calculator/fr/electrical-energy-calculator/",
    description:
      "La calculatrice d'énergie électrique calcule l'énergie électrique en joules.",
    showMain: true,
  },
  {
    name: "Calculatrice de perte d'énergie",
    link: "/calculator/fr/energy-loss-calculator/",
    description:
      "La calculatrice de perte d'énergie calcule la quantité d'énergie perdue.",
    showMain: false,
  },
  {
    name: "Calculatrice de force de friction",
    link: "/calculator/fr/friction-force/",
    description:
      "La calculatrice de force de friction calcule la force de friction.",
    showMain: true,
  },
  {
    name: "Calculatrice d'énergie cinétique",
    link: "/calculator/fr/kinetic-energy-calculator/",
    description:
      "La calculatrice d'énergie cinétique calcule l'énergie cinétique d'un objet en mouvement.",
    showMain: true,
  },
  {
    name: "Loi d'Ohm",
    link: "/calculator/fr/ohms-law/",
    description:
      "La calculatrice de la loi d'Ohm calcule la relation entre tension, courant et résistance.",
    showMain: true,
  },
  {
    name: "Calculatrice d'énergie des photons",
    link: "/calculator/fr/photon-energy/",
    description:
      "La calculatrice d'énergie des photons calcule l'énergie des photons.",
    showMain: true,
  },
  {
    name: "Calculatrice d'énergie potentielle",
    link: "/calculator/fr/potential-energy-calculator/",
    description:
      "La calculatrice d'énergie potentielle calcule l'énergie potentielle d'un objet.",
    showMain: true,
  },
  {
    name: "Calculatrice de pression",
    link: "/calculator/fr/pressure/",
    description:
      "La calculatrice de pression calcule la pression en pascals (Pa).",
    showMain: true,
  },
  {
    name: "Calculatrice de résistance",
    link: "/calculator/fr/resistor-calculator/",
    description:
      "La calculatrice de résistance calcule la résistance d'une résistance.",
    showMain: true,
  },
  {
    name: "Calculatrice solaire",
    link: "/calculator/fr/solar-calculator/",
    description:
      "La calculatrice solaire calcule l'énergie solaire et l'irradiation.",
    showMain: false,
  },
  {
    name: "Calculatrice de capacité du transformateur",
    link: "/calculator/fr/transformer-capacity-calculator/",
    description:
      "La calculatrice de capacité du transformateur calcule la capacité et la puissance d'un transformateur.",
    showMain: true,
  },
  {
    name: "Calculatrice de vitesse",
    link: "/calculator/fr/velocity/",
    description:
      "La calculatrice de vitesse calcule la vitesse d'un objet.",
    showMain: true,
  },
  {
    name: "Calculatrice de densité de l'eau",
    link: "/calculator/fr/water-density-calculator/",
    description:
      "La calculatrice de densité de l'eau calcule la densité de l'eau à différentes températures.",
    showMain: false,
  },
  {
    name: "Calculatrice d'ondes",
    link: "/calculator/fr/wave/",
    description:
      "La calculatrice d'ondes calcule les propriétés des ondes, y compris la longueur d'onde et la fréquence.",
    showMain: true,
  },
];
